import { readable } from 'svelte/store';
const canvas = typeof document !== 'undefined' ? document.createElement('canvas') : null;
if (canvas) {
    canvas.width = 500;
    canvas.height = 500;
}
// This can technically be null on the server, but we don't need to
// worry about that for now:
export const context = readable(canvas.getContext('2d', {
    willReadFrequently: true
}));
